import Vue from 'vue';
import {EventBus} from './utils/event-bus'
Vue.directive('collect', {
  bind(el, binding) {
    el.addEventListener('click', (e) => {
      if(binding.value.label=='query'){
        EventBus.$emit("collect-query",{...binding.value,type:2});
      }
      EventBus.$emit("collect",{...binding.value,type:2});

    }, false);
  }
});
Vue.directive('collect-query', {
  bind(el, binding) {
    el.addEventListener('click', (e) => {
    // EventBus.$emit("collect-query",{...binding.value,type:2});
    }, false);
  }
});



// WEBPACK FOOTER //
// ./src/directive.js